exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ps-posts-feed__header{display:flex;justify-content:flex-end;align-items:center;margin-bottom:20px;height:47px;width:100%}.ps-posts-feed__header-text-container{margin-right:auto}.ps-posts-feed__header-text{font-size:15px;font-weight:500}.ps-posts-feed__filter{display:flex;align-items:center;border:1px solid #ebedf1;border-radius:5px;height:47px}\n", ""]);

// exports
